import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '@/utils/store';

export interface competitionNavDataJson {
  id: number;
  title: string;
  background_one: string;
  background_two: string;
}

export interface CompetiitonState {
  competitionNavList: competitionNavDataJson[];
}

const localGameInfo = LocalStore.getValue<CompetiitonState>('SET_COMPETITION_INFO') || {};

export const competitionInfo: CompetiitonState = {
  competitionNavList: [],
  ...localGameInfo
};

export const setCompetiitonInfo: (payload: CompetiitonState) => IAction<CompetiitonState> = (
  payload: CompetiitonState
) => ({
  type: 'setCompetiitonInfo',
  payload
});

const competitionReducer: Reducer<CompetiitonState, IAction<any>> = (state = competitionInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setCompetiitonInfo':
      LocalStore.setValue('SET_COMPETITION_INFO', payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default competitionReducer;
